import React from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import { Logo } from '@pmndrs/branding'
import { App } from './App'

/*
Model JSX auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.3 model.glb --transform --simplify --resolution=2048
Author: Omar Faruq Tawsif (https://sketchfab.com/omarfaruqtawsif32)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
*/

function Root() {
  // compute today's date in MM/DD/YYYY format
  const today = new Date()
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const dd = String(today.getDate()).padStart(2, '0')
  const yyyy = today.getFullYear()
  const dateStr = `${mm}/${dd}/${yyyy}`

  return (
    <>
      <App />
      <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh' }}>
        {/* <a
          href="https://www.linkedin.com/in/henry-simon-374904153"
          style={{ position: 'absolute', bottom: 40, left: 90, fontSize: '13px' }}
        >
          Henry Simon
          <br />
          LinkedIn
        </a>
        <div style={{ position: 'absolute', bottom: 40, right: 40, fontSize: '13px' }}>
          {dateStr}
        </div>
        <Logo style={{ position: 'absolute', bottom: 40, left: 40, width: 30 }} /> */}
        {/* <a style={{ position: 'absolute', top: 40, left: 40, fontSize: '13px' }}>
          <p>scroll or click to navigate</p>
          <p>click on a card to inspect</p>
        </a> */}
      </div>
    </>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
